import script from "./AppBtnIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppBtnIcon.vue?vue&type=script&setup=true&lang=ts"

import "./AppBtnIcon.vue?vue&type=style&index=0&id=5edb910e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/EthVM/EthVM/v2/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5edb910e"]])

export default __exports__